module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/075-antigua-and-barbuda-e541528aae83e6031664d34b95f33702.svg";